import TextLoading from '@/app/common/components/skeleton/TextLoading';

const LINE_WIDTHS = [
  92, 78, 85, 68, 74, 58, 63, 48, 55, 42, 50, 38, 45, 35, 40, 30
];

const SearchVolumeDrawerPreload = () => (
  <div aria-busy="true">
    <div className="d-flex gap-2 flex-wrap align-items-center justify-content-between w-100">
      <div className="d-flex gap-2 flex-wrap align-items-center">
        <TextLoading width={70} height={14} isWidthPx />
        <TextLoading width={32} height={18} isWidthPx />
        <TextLoading width={60} height={14} isWidthPx />
        <TextLoading width={32} height={18} isWidthPx />
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2" dir="ltr">
        <TextLoading width={72} height={28} isWidthPx />
        <TextLoading width={64} height={14} isWidthPx />
        <div className="d-flex align-items-center gap-2 ms-5">
          <TextLoading width={32} height={28} isWidthPx />
          <TextLoading width={32} height={28} isWidthPx />
          <TextLoading width={32} height={28} isWidthPx />
        </div>
      </div>
    </div>

    <div
      className="mt-3 bg-100 rounded-2 position-relative overflow-hidden"
      style={{ height: '24.75rem' }}
    >
      <div
        className="position-absolute d-flex flex-column justify-content-between"
        style={{ top: '1.5rem', left: '1rem', bottom: '2.5rem', width: 32 }}
      >
        {Array.from({ length: 5 }, (_, index) => (
          <TextLoading key={index} width={28} height={10} isWidthPx />
        ))}
      </div>
      <div
        className="position-absolute d-flex flex-column justify-content-between"
        style={{
          top: '2rem',
          left: '3.5rem',
          right: '1rem',
          bottom: '2.75rem',
          direction: 'ltr'
        }}
      >
        {LINE_WIDTHS.map((width, index) => (
          <span key={index} style={{ opacity: index % 2 ? 0.55 : 1 }}>
            <TextLoading width={width} height={3} />
          </span>
        ))}
      </div>
      <div
        className="position-absolute d-flex justify-content-between gap-2"
        style={{ left: '3.5rem', right: '1rem', bottom: '0.75rem' }}
      >
        {Array.from({ length: 7 }, (_, index) => (
          <TextLoading key={index} width={48} height={10} isWidthPx />
        ))}
      </div>
    </div>
  </div>
);

export default SearchVolumeDrawerPreload;
